import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { count } from 'rxjs/operators';
import { AuthService } from 'src/app/_services/auth.service';
import { PropertiesService } from '../_services/company/properties.service';
import * as Highcharts from 'highcharts';
import HC_exporting from 'highcharts/modules/exporting';

declare var require: any;
let Boost = require('highcharts/modules/boost');
let noData = require('highcharts/modules/no-data-to-display');
let More = require('highcharts/highcharts-more');

Boost(Highcharts);
noData(Highcharts);
More(Highcharts);
noData(Highcharts);
HC_exporting(Highcharts);


@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {


  public options: any = {
    chart: {
        type: 'area'
    },
    title: {
        text: 'Sale Chart'
    },
    subtitle: {
        text: 'Source: Sale graph'
    },
    yAxis: {
        title: {
            useHTML: true,
            text: 'Amount'
        }
    },
    tooltip: {
        shared: true,
        headerFormat: '<span style="font-size:12px"><b>{point.key}</b></span><br>'
    },
    credits:{
      enabled: false
    },
    exporting:{
      enabled: true
    },
    plotOptions: {
        series: {
            pointStart: 2012
        },
        area: {
            stacking: 'normal',
            lineColor: '#666666',
            lineWidth: 1,
            marker: {
                lineWidth: 1,
                lineColor: '#666666'
            }
        }
    },
    series: [{
        name: 'Ocean transport',
        data: [13234, 12729, 11533, 17798, 10398, 12811, 15483, 16196, 16214]
    }, {
        name: 'Households',
        data: [6685, 6535, 6389, 6384, 6251, 5725, 5631, 5047, 5039]

    }, {
        name: 'Agriculture and hunting',
        data: [4752, 4820, 4877, 4925, 5006, 4976, 4946, 4911, 4913]
    }, {
        name: 'Air transport',
        data: [3164, 3541, 3898, 4115, 3388, 3569, 3887, 4593, 1550]

    }, {
        name: 'Construction',
        data: [2019, 2189, 2150, 2217, 2175, 2257, 2344, 2176, 2186]
    }]
  };


  headerColor = 'primary';
  constructor(private titleService: Title, 
    public propertiesService: PropertiesService, 
    private router:Router,
    public authService : AuthService) { }

  ngOnInit() {
    this.titleService.setTitle('Main Dashboard');
    Highcharts.chart('area-chart-container', this.options);
  }

  onOpenHotelDasbhoard()
  {
    this.propertiesService.get_our_property().subscribe(data=>{
      console.log(data);
      if(data['status']){
        if(data['data']['property_type']){
          this.router.navigateByUrl('/hotel');
        }
        else
        {
          this.router.navigateByUrl('/company/property');
        }
      }
    });
  }

  onOpenRestaurantDasbhoard()
  {
    this.propertiesService.get_our_property().subscribe(data=>{
      console.log(data);
      if(data['status']){
        if(data['data']['property_type']){
          this.router.navigateByUrl('/restaurant/orders');
        }
        else
        {
          this.router.navigateByUrl('/company/property');
        }
      }
    });
  }

  onOpenSchoolDasbhoard()
  {
    this.router.navigateByUrl('/school');
  }

  onOpenInstructorDasbhoard()
  {
    this.router.navigateByUrl('/instructor');
  }

  onOpenEcomDasbhoard(){
    this.router.navigateByUrl('/ecom');
  }

  onOpenLearCrmDasbhoard(){
    this.router.navigateByUrl('/leadcrm');
  }

  onOpenChemistShopDasbhoard(){
    this.router.navigateByUrl('/chemistshop');
  }

}


